module.exports = __webpack_public_path__ + "img/63.9071d2d8.jpg";